"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getCurrentBrowserLanguage = require("./getCurrentBrowserLanguage");
Object.keys(_getCurrentBrowserLanguage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getCurrentBrowserLanguage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getCurrentBrowserLanguage[key];
    }
  });
});
var _getTargetUrl = require("./getTargetUrl");
Object.keys(_getTargetUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getTargetUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getTargetUrl[key];
    }
  });
});
var _getUrlQueryParam = require("./getUrlQueryParam");
Object.keys(_getUrlQueryParam).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getUrlQueryParam[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getUrlQueryParam[key];
    }
  });
});
